/**
 * Read-only connection gate for every mutating control (spec §12.2: disabled
 * with the tooltip "Connection is read-only (edit connection to change)").
 * Nothing mutating ships in S1; the hook exists so S2+ never hand-roll the rule.
 */
import { STORAGE_READ_ONLY_REASON } from '../../../../core/engines/azureStorageRefusal';
import { useConnectionStore } from '../../../connections/store/connectionStore';

export function useStorageReadOnly(connectionId: string): { readOnly: boolean; reason: string | undefined } {
  const readOnly = useConnectionStore((s) => {
    const saved = s.connections.find((c) => c.id === connectionId);
    const active = s.activeConnections.find((c) => c.id === connectionId);
    return !!(saved?.readOnly ?? active?.connection.readOnly);
  });
  return { readOnly, reason: readOnly ? STORAGE_READ_ONLY_REASON : undefined };
}
